'use strict';

class PaginationDirective {
  constructor() {
    'ngInject';

    this.restrict = 'E';
    this.require = 'paginationObject';
    this.scope = {
      pgObject: '=',
      action: '&'
    };
    this.template = require('./pagination.html');
  }
}

export default angular.module('leptonApp.pagination', [])
  .directive('pagination', [() => new PaginationDirective()])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/directive/pagination-directive/pagination.directive.js